exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.app-container.all-trips,\r\n.app-container.all-trips main,\r\n.app-container.all-trips #main {\r\n    min-height: 0 !important;\r\n    margin-bottom: 0 !important;\r\n    padding-bottom: 0 !important;\n}\n.app-container.all-trips .view-container {\r\n    padding-bottom: 0 !important;\r\n    margin-bottom: 0 !important;\n}\n.app-container.all-trips .footer-component {\r\n    display: none !important;\n}\r\n", ""]);

// exports
